
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AdminProtectedRoute } from "@/components/admin/AdminProtectedRoute";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminAccessDenied from "@/pages/admin/AdminAccessDenied";
import AdminControlCenter from "@/pages/admin/AdminControlCenter";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCompanies from "@/pages/admin/AdminCompanies";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminPlans from "@/pages/admin/AdminPlans";
import AdminBilling from "@/pages/admin/AdminBilling";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminCommunication from "@/pages/admin/AdminCommunication";
import AdminWhatsAppChat from "@/pages/admin/AdminWhatsAppChat";

export const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminLogin />} />
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/access-denied" element={<AdminAccessDenied />} />
      
      <Route element={<AdminProtectedRoute />}>
        <Route path="/control-center" element={<AdminControlCenter />} />
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/companies" element={<AdminCompanies />} />
        <Route path="/users" element={<AdminUsers />} />
        <Route path="/plans" element={<AdminPlans />} />
        <Route path="/billing" element={<AdminBilling />} />
        <Route path="/communication" element={<AdminCommunication />} />
        <Route path="/whatsapp-chat" element={<AdminWhatsAppChat />} />
        <Route path="/settings" element={<AdminSettings />} />
      </Route>
      
      {/* Catch-all route for undefined admin routes */}
      <Route path="*" element={<Navigate to="/admin/access-denied" replace />} />
    </Routes>
  );
};
